import type { IconData } from '@stacksjs/iconify-core'

export const basicArrowsDownRightCircle: IconData = {
  "body": "<path fill=\"currentColor\" fill-rule=\"evenodd\" d=\"M13.657 2.343A8 8 0 1 0 2.343 13.657A8 8 0 0 0 13.657 2.343m-2.475 8.84H5.525L6.94 9.767L4.111 6.939l2.828-2.828l2.829 2.828l1.414-1.414z\" clip-rule=\"evenodd\"/>",
  "width": 24,
  "height": 24,
  "viewBox": "0 0 24 24"
}

export default basicArrowsDownRightCircle
